export const TEST_IDS = {
  // Login
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",

  // Sidebar nav
  navProjection: "nav-projection",
  navCollections: "nav-collections",
  navSales: "nav-sales",
  navMilestones: "nav-milestones",
  navLandSales: "nav-land-sales",
  navOngoing: "nav-ongoing",
  navActuals: "nav-actuals",
  navReconciliation: "nav-reconciliation",
  navFlags: "nav-flags",
  navImport: "nav-import",
  navSettings: "nav-settings",
  navWhatIf: "nav-what-if",
  navScenarios: "nav-scenarios",
  navLogout: "nav-logout",

  // Projection
  horizonChip: (m) => `horizon-chip-${m}m`,
  kpiProjected: "kpi-projected-total",
  kpiPeak: "kpi-peak-month",
  kpiMilestones: "kpi-milestone-count",
  kpiFlags: "kpi-open-flags",
  chartTimeline: "collections-timeline-chart",
  projectRow: (name) => `project-row-${name}`,
  projectTypeFilter: "filter-project-type",
  projectFilter: "filter-project",

  // Reconciliation
  reconChart: "recon-chart",
  reconRow: (name) => `recon-row-${name}`,

  // Data-table CRUD (generic)
  addRow: (module) => `${module}-add-row`,
  editRow: (module, id) => `${module}-edit-${id}`,
  deleteRow: (module, id) => `${module}-delete-${id}`,
  saveRow: (module) => `${module}-save`,
  cancelRow: (module) => `${module}-cancel`,
  searchInput: (module) => `${module}-search`,

  // Flags
  flagCard: (id) => `flag-card-${id}`,
  flagResolve: (id) => `flag-resolve-${id}`,
  flagReopen: (id) => `flag-reopen-${id}`,
  flagStatusToggle: "flag-status-toggle",

  // Import
  uploadInput: "upload-file-input",
  uploadSubmit: "upload-submit-btn",
  uploadSummary: "upload-summary",

  // Settings
  settingsBookingPct: "settings-booking-pct",
  settingsNextPct: "settings-next-pct",
  settingsAsOf: "settings-as-of",
  settingsSave: "settings-save",

  // What-if Simulator
  simulatorOpenBtn: "simulator-open-btn",
  simulatorDrawer: "simulator-drawer",
  simulatorClose: "simulator-close-btn",
  simulatorBookingPct: "simulator-booking-pct",
  simulatorNextPct: "simulator-next-pct",
  simulatorSalesMult: "simulator-sales-mult",
  simulatorProjectSelect: "simulator-project-select",
  simulatorExtraPct: "simulator-extra-pct",
  simulatorExtraMonth: "simulator-extra-month",
  simulatorAddExtra: "simulator-add-extra-btn",
  simulatorExtraRow: (i) => `simulator-extra-row-${i}`,
  simulatorRemoveExtra: (i) => `simulator-remove-extra-${i}`,
  simulatorReset: "simulator-reset-btn",
  simulatorProjectedTotal: "simulator-projected-total",
  simulatorDelta: "simulator-delta",

  // What-if page (save + version)
  whatIfSaveBtn: "whatif-save-btn",
  whatIfSaveModal: "whatif-save-modal",
  whatIfSaveName: "whatif-save-name",
  whatIfSaveNote: "whatif-save-note",
  whatIfSaveFreeze: "whatif-save-freeze",
  whatIfSaveMode: "whatif-save-mode",  // 'new' or 'version'
  whatIfSaveConfirm: "whatif-save-confirm",
  whatIfSaveCancel: "whatif-save-cancel",
  whatIfLoadedScenario: "whatif-loaded-scenario",

  // Scenarios page
  scenariosPage: "scenarios-page",
  scenarioCard: (id) => `scenario-card-${id}`,
  scenarioOpen: (id) => `scenario-open-${id}`,
  scenarioDelete: (id) => `scenario-delete-${id}`,
  scenarioVersionRow: (id, v) => `scenario-${id}-v${v}`,
  scenarioLoadVersion: (id, v) => `scenario-${id}-v${v}-open`,

  // Scenario diff / compare-live
  scenarioDiffBtn: (id) => `scenario-${id}-diff-btn`,
  scenarioDiffFromSel: "scenario-diff-from",
  scenarioDiffToSel: "scenario-diff-to",
  scenarioDiffModal: "scenario-diff-modal",
  scenarioDiffClose: "scenario-diff-close",
  scenarioCompareLiveBtn: (id, v) => `scenario-${id}-v${v}-vs-live`,
  scenarioCompareLiveModal: "scenario-compare-live-modal",

  // Collections page
  collectionsPage: "collections-page",
  collectionsViewToggle: "collections-view-toggle",
  collectionsLedgerView: "collections-ledger-view",
  collectionsExportBtn: "collections-export-btn",
  collectionsPasteBtn: "collections-paste-btn",
  collectionsPasteModal: "collections-paste-modal",
  collectionsPasteTextarea: "collections-paste-textarea",
  collectionsPasteConfirm: "collections-paste-confirm",
  collectionsPasteCancel: "collections-paste-cancel",
  collectionsLedgerRow: (id) => `ledger-row-${id}`,
  collectionsLedgerActualInput: (id) => `ledger-actual-input-${id}`,
  collectionsSaveBtn: "collections-save-btn",
  collectionsDiscardBtn: "collections-discard-btn",
  collectionsOutlierToggle: "collections-outlier-toggle",

  // Sales version history
  salesSubmitBtn: "sales-submit-version-btn",
  salesVersionsBtn: "sales-versions-btn",
  salesVersionsDrawer: "sales-versions-drawer",
  salesVersionsClose: "sales-versions-close",
  salesSubmitNoteInput: "sales-submit-note",
  salesSubmitConfirm: "sales-submit-confirm",
  salesSubmitCancel: "sales-submit-cancel",
  salesVersionRow: (v) => `sales-version-row-${v}`,
  salesVersionActivate: (v) => `sales-version-activate-${v}`,
  salesVersionDelete: (v) => `sales-version-delete-${v}`,
  salesActiveVersionPill: "sales-active-version-pill",

  // Sales bookings grid (Excel-like pivot)
  salesGridPage: "sales-page",
  salesGridCell: (pid, m) => `sales-cell-${pid}-${m}`,
  salesGridCellInput: (pid, m) => `sales-cell-input-${pid}-${m}`,
  salesGridSaveBtn: "sales-grid-save-btn",
  salesGridDiscardBtn: "sales-grid-discard-btn",

  // Import history
  importHistoryPage: "import-history-page",
  importHistoryRow: (id) => `import-history-row-${id}`,

  // Exports
  exportProjectionBtn: "export-projection-btn",
  exportReconciliationBtn: "export-reconciliation-btn",

  // Treasury
  navTreasury: "nav-treasury",
  treasuryPage: "treasury-page",
  treasuryOpeningInput: "treasury-opening-input",
  treasuryThresholdInput: "treasury-threshold-input",
  treasurySaveSettings: "treasury-save-settings",
  treasuryOutflowAddBtn: "treasury-outflow-add-btn",
  treasuryOutflowNewName: "treasury-outflow-new-name",
  treasuryOutflowNewMonth: "treasury-outflow-new-month",
  treasuryOutflowNewAmount: "treasury-outflow-new-amount",
  treasuryOutflowNewCategory: "treasury-outflow-new-category",
  treasuryOutflowSubmit: "treasury-outflow-submit",
  treasuryOutflowRow: (id) => `treasury-outflow-row-${id}`,
  treasuryOutflowDelete: (id) => `treasury-outflow-delete-${id}`,
  treasurySimulateName: "treasury-simulate-name",
  treasurySimulateAmount: "treasury-simulate-amount",
  treasurySimulateMonth: "treasury-simulate-month",
  treasurySimulateApply: "treasury-simulate-apply",
  treasurySimulateClear: "treasury-simulate-clear",
  treasuryKpiClosing: "treasury-kpi-closing",
  treasuryKpiTrough: "treasury-kpi-trough",
  treasuryKpiShortfall: "treasury-kpi-shortfall",
};
